import api from "./api";

export async function getDrivers(params) {
  const res = await api.get("/driver", { params });
  return res.data.data; 
}
export async function getDriver(id) {
  const res = await api.get(`/driver/${id}`);
  return res.data.data;
}

export async function createDriver(payload) {
  const res = await api.post("/driver/createDriver", payload);
  return res.data.data;
}

export async function updateDriver(id, payload) {
  const res = await api.put(`/driver/${id}`, payload);
  return res.data.data;
}

export async function deleteDriver(id) {
  const res = await api.delete(`/driver/${id}`);
  return res.data.data;
}

export async function approveDriver(id, isActive) {
  const res = await api.post(`/driver/approve/${id}`, { isActive });
  return res.data.data;
}

export async function disapproveDriver(id) {
  const res = await api.post(`/driver/disapprove/${id}`);
  return res.data.data;
}

